<template>
  <FusionReleaseNotesHistory />
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({})
</script>
